import { apiCall } from "../../services/api-service.js";

const get  = (endpoint, params) => apiCall("get",    endpoint, null,  { params });
const post = (endpoint, body)   => apiCall("post",   endpoint, body);
const put  = (endpoint, body)   => apiCall("put",    endpoint, body);
const del  = (endpoint)         => apiCall("delete", endpoint);

export const getProductListApi    = (params)    => get(`products`, params);
export const submitProductAPI     = (body)      => post(`products`, body);
export const updateProductAPI     = (id, body)  => put(`products/${id}`, body);
export const saveAttachmentApi    = (id, body)  => put(`products/attachment/${id}`, body);
export const getProductEditApi    = (id)        => get(`products/edit/${id}`);
export const getProductDetailsApi = (id)        => get(`products/view/${id}`);
export const deleteProductApi     = (id)        => del(`products/${id}`);

export const updateStatusApi = async (id, body) => {
  const response = await put(`products/status/${id}`, body);
  return response.data;
};